<template>
	<main class="zov-layout-content"><slot>Content</slot></main>
</template>
<script>
const prefix = 'zov-layout-content'
export default {
	name: prefix
}
</script>
